import { useState } from 'react';
import { MarksmanGradingClient, MarksmanGradingQualificationDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useMarksmanGradingApi = () => {
    const apiClient = new MarksmanGradingClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const getMemberQualifications = async (memberId: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getMemberMarksmanQualifications(memberId);
        } catch (err: any) {
            setError(err.message || 'Error fetching member qualifications');
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    const calculateGrading = async (request: any) => {
        setIsLoading(true);
        try {
            return await apiClient.calculateMarksmanGrading(request);
        } catch (err: any) {
            setError(err.message || 'Error calculating marksman grading');
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    const calculateGradingForType = async (memberId: string, year: number, gradingTypeId: string) => {
        setIsLoading(true);
        try {
            return await apiClient.calculateMarksmanGradingForType(memberId, year, gradingTypeId);
        } catch (err: any) {
            setError(err.message || 'Error calculating marksman grading for type');
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    const generateCertificate = async (memberId: string, categoryQualification: any) => {
        setIsLoading(true);
        try {
            const request = {
                memberId,
                categoryQualification
            };
            return await apiClient.generateMarksmanGradingCertificate(request);
        } catch (err: any) {
            setError(err.message || 'Error generating marksman grading certificate');
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    return {
        isLoading,
        error,
        getMemberQualifications,
        calculateGrading,
        calculateGradingForType,
        generateCertificate
    };
};
